<script lang="ts">
	import { NavBar } from '#lib/features/navigation/components/NavBar/index.js';
	import { GlobalSearch } from '#lib/features/search/global/components/GlobalSearch/index.js';
	import { ArtistsHeader } from '#lib/websites/artists/components/ArtistsHeader/index.js';
	import { SearchPageContainer } from '$global/features/search/components/SearchPageContainer';
	import { createSearchCombobox } from '$global/features/search/utils/createSearchCombobox';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const combobox = createSearchCombobox();
</script>

<NavBar SearchComponent={GlobalSearch} {combobox} isSearchEnabled={true}>
	{#snippet homeIcon()}
		<ArtistsHeader />
	{/snippet}
</NavBar>
<SearchPageContainer {combobox}>
	{@render children?.()}
</SearchPageContainer>
